const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`<div class="demo-u-size-responsive">
  <div class="u-size-inline-1/2 u-size-inline-2/3@s u-size-inline-3/4@m u-size-inline-4/5@l u-size-inline-5/6@xl t-dark t-alternate u-rounded u-pad-n1">
    <div>1/2</div>
    <div>2/3@s</div>
    <div>3/4@m</div>
    <div>4/5@l</div>
    <div>5/6@xl</div>
  </div>
  <div class="u-size-inline-1/2 u-size-inline-1/3@s u-size-inline-1/4@m u-size-inline-1/5@l u-size-inline-1/6@xl t-dark t-alternate u-rounded u-pad-n1">
    <div>1/2</div>
    <div>1/3@s</div>
    <div>1/4@m</div>
    <div>1/5@l</div>
    <div>1/6@xl</div>
  </div>
</div>
`);
            }

            getTemplateName() {
                return `dd28770a0fe33b15fc3aba5b43780146f4155546dfc576aa70ae7802a2548442`;
            }

            getSourceContext() {
                return new this.Source(``, `dd28770a0fe33b15fc3aba5b43780146f4155546dfc576aa70ae7802a2548442`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'dd28770a0fe33b15fc3aba5b43780146f4155546dfc576aa70ae7802a2548442');

let template = env.loadTemplate('dd28770a0fe33b15fc3aba5b43780146f4155546dfc576aa70ae7802a2548442');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/utilities/size/demo/responsive.twig", args: context }
     );
     return rendered;;
};